import React from 'react';
import MotifIcon from '@ey/motif-react-wrapper/Icon';
import {labels} from '../../../util/utils';
import styled, {ThemeProvider} from 'styled-components';
import theme from '@ey/styled-theme';
import {navigationIcClose24px} from '@ey/motif-react-wrapper/assets/icons';

const RemoveAdminsTooltip = (props) => {
	const onCloseHandler = (e) => { };

	const getEntityName = () => {
		return props.nodes.find(x => x.id == props.nodeId).entityName;		
	}

	return (
		<StyledRemoveAdminsTooltip>
			<section className="header">
				<h3>
					<span title={getEntityName()} className="header-text ellipsis">
					{getEntityName()}{' '}
					</span>
					<span className="badge-count">{props.elements.length}</span>
				</h3>
				<MotifIcon
					title={labels.closeLabel}
					id="closeTooltip-admins"
					onClick={onCloseHandler}
					src={navigationIcClose24px}
				/>
			</section>
			<section className={`${_.size(props.elements) === 0 ? 'default-message tooltip-main' : 'tooltip-main'}`}>
				<section className="tooltip-body customScrollbar">
					<>
						{props.elements
							.sort()
							.map((element) => {
								return (
									<section className="eng-row">
										<span title={element} className="eng-name ellipsis">
											{element}
										</span>

									</section>
								);
							})}
					</>

				</section>
			</section>
		</StyledRemoveAdminsTooltip>
	);
};
export default RemoveAdminsTooltip;

const StyledRemoveAdminsTooltip = styled.section`
	display: flex;
	flex-direction: column;
	height: 100%;

	.header {
		width: 100%;
		background-color: ${(props) => props.theme.color[`grey100`]};
		border-bottom: solid 1px ${(props) => props.theme.color[`grey300`]};
		padding: 0.5rem 1rem;
		display: flex;
		align-items: center;
		justify-content: space-between;
		h3 {
			font-size: 1.3rem;
			margin: 0;
			display: flex;
			align-items: center;
			line-height: normal;
			font-weight: bold;
			max-width: 82%;
			.header-text {
				display: inline-block;
				width: 100%;
				margin-right: 1rem;
			}
		}
		.badge-count {
			background-color: ${(props) => props.theme.color[`grey500`]};
			color: ${(props) => props.theme.color[`white`]};
			font-size: 1rem;
			padding: 0.2rem 0.5rem;
			border-radius: 50%;
		}
		.motif-icon,
		svg {
			width: 2rem !important;
			height: 2rem !important;
		}
	}

	.tooltip-main {
		flex: 1;
		overflow: auto;

		&.default-message {
			font-size: 1.2rem;
			.tooltip-body {
				padding: 1rem;
				align-items: center;
				justify-content: center;
				.placeholder-message {
					width: 99%;
					display: inline-block;
					font-weight: 300;
					color: ${(props) => props.theme.color[`grey400`]};
					text-align: center;
				}
			}
		}
	}

	.tooltip-body {
		display: flex;
		flex-direction: column;
		width: 100%;
		flex: 1;
		overflow: auto;
		min-height: 15rem;
		max-height: 15rem;
		.eng-row {
			padding: 1rem;
			display: flex;
			justify-content: space-between;
			align-items: center;
			line-height: 1.9rem;
			border-bottom: solid 1px ${(props) => props.theme.color[`grey300`]};

			&:last-child {
				border-bottom: 0;
			}
			.clear-row {
				transform: rotate(135deg);
				display: inline-block;
				width: 2rem;
				height: 2rem;
				svg {
					max-width: 2rem;
					max-height: 2rem;
					fill: ${(props) => props.theme.color[`black`]};
				}
			}	
			.eng-col {
				display: flex;
				flex-direction: column;
				width: 90%;
			}

			.domains-container{
				display: flex;
				align-items: center;
				max-width: 60%;
			}

			.domains-label,
			.views-label {
				display: inline-block;
				max-width: 35%;
				// width: 5rem;
				margin-right: 0.5rem;    
				font-size: 1.1rem;
				font-weight: 300;
			}

			.motif-badge {
				font-size: 0.8rem;
				padding: 0.2rem;
				margin-right: 0.5rem;
			}

			.eng-group-wrap {
				display: flex;
				font-size: 1rem;
				align-items: center;
				width: 100%;
				.partner-wrap {
					display: flex;
					align-items: center;
					margin-right: 0.5rem;
					max-width: 40%;
					span {
						max-width: 11rem;
					}
				}
			}

			.eng-wrap,
			.client-wrap {
				width: 100%;
				display: flex;
				font-size: 1.2rem;
			}
			.eng-wrap {
				font-weight: bold;
			}

			.eng-name,
			.client-name {
				display: inline-block;
				margin-right: 0.5rem;
			}

			.client-name{				
				max-width: 100% !important;
			}
			.eng-name{
				max-width: 100%;
			}

			.eng-id,
			.client-code {
				margin-left: 0.5rem;
				display: inline-block;
				width: 40% !important;
			}

			.client-code,
			.client-name {
				font-size: 1.1rem;
				font-weight: 300;
			}
		}
	}

	.ellipsis {
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
	}
`;
